module.exports = __webpack_public_path__ + "img/cvac.e41d6af5.png";